import React from 'react'
import { aialertsProps } from './aialerts-interface'
import { Button, Modal } from 'antd'

const Aialerts = ({ open, closeModal, alertType, title, description, actionText, actionFunc, extraActionText, extraActionFunc, actionLoading, extraActionLoading }: aialertsProps) => {

	const getAlertBackDrop = () => {
		switch (alertType) {
			case 'error':
				return '/img/vectors/redalert.svg';
			case 'success':
				return '/img/vectors/greenalert.svg';
			case 'warning':
				return '/img/vectors/yellowalert.svg';
			case 'noLife':
				return '/img/vectors/heartWings.jpg';
			default:
				return '';
		}
	}

	return (
		<div>
			<Modal
				closable={false}
				open={open}
				onOk={() => {
					closeModal()
				}}
				onCancel={() => {
					closeModal()
				}}
				footer={null}
				width={'40rem'}
				className='white-bg-modal'
			>
				<div className='relative'>
					<div className='absolute rounded-full bg-appcolorgreyfive custom-box-shadow-five p-[0.9rem] w-fit cursor-pointer right-0'
						onClick={() => {
							closeModal()
							if (actionFunc !== undefined) {
								actionFunc()
							}
						}}
					>
						<img src="/img/vectors/modalclose.svg" alt="" />
					</div>


					<div>
						{
							getAlertBackDrop() !== '' ?
								<div
									className='w-full h-[19rem] rounded-[20px]'
									style={{
										backgroundImage: `url(${getAlertBackDrop()})`,
										backgroundSize: 'cover',
										backgroundRepeat: 'no-repeat',
										backgroundPosition: 'center center',
									}}
								>
								</div>
								: null
						}

						<div>
							<h1 className='font-semibold text-center text-appcolorblackfaint text-[27px] leading-[33px] my-[1.5rem]'>{title}</h1>

							<div className='opacity-[0.5] text-[20px] leading-[24px] text-center w-[80%] mx-auto'>
								{description}
							</div>

							<div className='mt-[3.4rem] flex justify-center'>
								{
									actionText !== undefined && actionFunc !== undefined
										?
										<div>
											<Button
												onClick={() => {
													actionFunc?.()
												}}
												disabled={actionLoading}
												className='mr-[0.9rem] custom-primary-one-btn white-text smaller-padding'>
												{actionText}
											</Button>
										</div>
										: null
								}

								{
									extraActionText !== undefined && extraActionFunc !== undefined
										?
										<div>
											<Button
												onClick={() => {
													extraActionFunc?.()
												}}
												disabled={extraActionLoading}
												className='mr-[0.9rem] custom-grey-btn smaller-padding black-text'>
												{extraActionText}
											</Button>
										</div>
										: null
								}
							</div>
						</div>
					</div>
				</div>
			</Modal >
		</div >
	)
}

export default Aialerts